import type { SectionWidgetConfig } from '../../types';
import { SportsWidgetType } from '../../widgets';
import { buildSportsLayoutPageResponse } from '../buildSportsLayoutPageResponse';

import {
  TXTWCL_Bet_on_N0_in_the_N1X_all_the_b_ELL,
  TXTWCL_N0_Betting_Odds
} from './sportsEvent.messages.json';

const sportsEventWidgets = () =>
  [
    {
      title: 'Sports Event Info Widget',
      _content_type_uid: SportsWidgetType.SportsEventInfo
    },
    {
      title: 'Sports Event Page Widget',
      _content_type_uid: SportsWidgetType.SportsEventPage
    } satisfies SectionWidgetConfig
  ] satisfies readonly SectionWidgetConfig[];

export const sportsEvent = () =>
  buildSportsLayoutPageResponse({
    alias: 'sportsEvent',
    seoConfig: {
      apiPath: '/meta/event/',
      descriptionTag: TXTWCL_Bet_on_N0_in_the_N1X_all_the_b_ELL,
      titleTag: TXTWCL_N0_Betting_Odds,
      translationsMap: {
        event: 'eventName',
        competition: 'competitionName'
      }
    },
    mainSectionWidgetConfigs: sportsEventWidgets()
  });
